import AGREGAR_CONTRATO_AGENDA from '@/graphql/mutations/administracion/contratos/contrato/agenda/agregarContratoAgenda.gql';
import ACTUALIZAR_CONTRATO_AGENDA from '@/graphql/mutations/administracion/contratos/contrato/agenda/actualizarContratoAgenda.gql';
import CONTRATO_AGENDAS from '@/graphql/querys/administracion/contratos/contrato/agenda/contratoAgendas.gql';
import ELIMINAR_CONTRATO_EVENTO from '@/graphql/mutations/administracion/contratos/contrato/agenda/eliminarContratoAgenda.gql';

export default {
  methods: {
    // Guardar agenda del contrato
    async mixAgregarAgenda() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_AGENDA,
          variables: {
            contratoAgenda: this.evento,
          },
          update: (store, { data: { agregarContratoAgenda } }) => {
            const query = {
              query: CONTRATO_AGENDAS,
              variables: { idContrato: this.idContrato },
            };
            const { contratoAgendas } = store.readQuery(query);
            const contratoAgendasCopia = contratoAgendas.slice();
            contratoAgendasCopia.push(agregarContratoAgenda);
            store.writeQuery({
              ...query,
              data: {
                contratoAgendas: contratoAgendasCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
          this.cerrar();
        })
        .catch((error) => {
          this.mixMensajeError(error);
        })
        .finally(() => {
          this.enviandoFormulario = false;
          this.mixEsCargando(false);
        });
    },
    async mixActualizarAgenda() {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: ACTUALIZAR_CONTRATO_AGENDA,
          variables: {
            id: this.editEvento.id,
            contratoAgenda: this.evento,
          },
          update: (store, { data: { actualizarContratoAgenda } }) => {
            const query = {
              query: CONTRATO_AGENDAS,
              variables: { idContrato: this.idContrato },
            };
            const data = store.readQuery(query);
            const { contratoAgendas } = data;
            const index = contratoAgendas
              .findIndex((contratoAgenda) => contratoAgenda.id
              === actualizarContratoAgenda.id);
            if (index !== -1) {
              contratoAgendas.splice(index, 1, actualizarContratoAgenda);
            }
            store.writeQuery({ ...query, data });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
          this.cerrar();
        })
        .catch((error) => {
          this.mixMensajeError(error);
        })
        .finally(() => {
          this.enviandoFormulario = false;
          this.mixEsCargando(false);
        });
    },
    async mixEliminarAgenda(idEvento) {
      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: ELIMINAR_CONTRATO_EVENTO,
          variables: {
            id: idEvento,
          },
          update: (store) => {
            const query = {
              query: CONTRATO_AGENDAS,
              variables: { idContrato: this.idContrato },
            };
            const { contratoAgendas } = store.readQuery(query);
            const contratoAgendasCopia = contratoAgendas.slice();
            const index = contratoAgendasCopia
              .findIndex((contratoAgenda) => contratoAgenda.id === idEvento);
            if (index !== -1) {
              contratoAgendasCopia.splice(index, 1);
            }
            store.writeQuery({
              ...query,
              data: {
                contratoAgendas: contratoAgendasCopia,
              },
            });
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
          this.cerrar();
        })
        .catch((error) => {
          this.mixMensajeError(error);
        })
        .finally(() => {
          this.enviandoFormulario = false;
          this.mixEsCargando(false);
        });
    },
  },
};
